const APP_TITLE_SUFFIX = 'LMS | Coditas';

export function formatPageTitle(page: string): string {
  return `${page} | ${APP_TITLE_SUFFIX}`;
}
